// Port of api/fuel/app/classes/filter/search/games/sorts/query/play/duration.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'play.duration',
	post: false,
	require: function(config, filter) { return sorted('play.duration', filter) > 0 },
	run: function(config, filter, data, query) {
		query.where('p.play_length', '>', 0)
		query.order('p.play_length', sortReverse('play.duration', filter), sortPriority('play.duration', filter))
	}
}
